// NATIVE
import React, { useEffect, useState } from 'react';

// INSTALLED
import { useDispatch } from 'react-redux';
import { Breadcrumbs, Button, Divider, Typography } from '@mui/material';

// CUSTOM
import { mtDividerUpTable, timeToClosedToast } from '../../commons';
import { hasPemissions } from '../../commons/utils';
import { showIconRequestErrors } from '../../store/errors';
import MultipleSnackbars from '../../components/MultipleSnackbars';
import { TableNovedadesTurno } from '../../components/tables/TableNovedadesTurno';
import {
  getNovedadesTurnoDataCreateStore,
  getNovedadesTurnoStore,
} from '../../store/novedadesTurnos';
import { CreateDialogNovedadesTurnos } from '../../components/modals/novedadesTurnos/CreateDialogNovedadesTurnos';
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle';
import { SnackAlert } from '../../components/SnackAlert';
import { AlertsInformativos } from '../../components/generics/AlertsInformativos';
import { alertInformativo } from '../../commons/texts';

export const NovedadesTurnos = () => {
  // USE DISPATCH
  const dispatch = useDispatch();

  // USE STATE
  const [data, setMsgErrors] = useState([]);
  const [openNovedad, setOpenNovedad] = useState(false);

  const [canCreate, setCanCreate] = useState(false);

  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [messagesAlerts, setMessagesAlerts] = React.useState<any>([]);

  const [alert_snack, setAlertSnack] = React.useState(false);
  const [msgSnack, setMsgSnack] = React.useState({
    msg: '',
    status: 'success',
  });

  // USE EFFECT
  useEffect(() => {
    checkCanCreate();
  }, []);

  const checkCanCreate = async () => {
    const havePermissions = await hasPemissions(
      'modulo.thumano',
      'modulo.novedades',
      'create',
      'modulo.novedadesturnos'
    );

    setCanCreate(havePermissions);
  };

  const openModal = async () => {
    //  nombre modulo     sub modulo          accion     sub sub module
    const havePermissions = await hasPemissions(
      'modulo.thumano',
      'modulo.novedades',
      'create',
      'modulo.novedadesturnos'
    );

    if (!havePermissions) {
      await validateLsPermissions('No tienes pemisos para (Crear) novedad turnos.');

      return false;
    }

    await dispatch(getNovedadesTurnoDataCreateStore());

    setOpenNovedad(true);
  };

  const handleCloseDialogNovedad = () => {
    setOpenNovedad(false);
  };

  const validateLsPermissions = async (message: string) => {
    const errors: any = {
      msg: message,
      status: 'error',
    };

    await setMsgSnack(errors);
    await setAlertSnack(true);
  };

  return (
    <>
      <MultipleSnackbars
        messagesList={messagesAlerts}
        position={'bottom-left'}
        autoClose={timeAlert}
      />
      <SnackAlert
        open={alert_snack}
        onclick={setAlertSnack}
        text={msgSnack.msg}
        severity={msgSnack.status}
      />

      <BreadCrumbsAndTitle
        title="Listado  Novedades Turnos"
        mainModule="Talento Humano"
        parent="Listado  Novedades Turnos"
        action=""
      />

      <div style={{ display: 'flex', justifyContent: 'end' }}>
        {canCreate && (
          <Button variant="contained" sx={{ marginBottom: 3 }} onClick={openModal}>
            Crear Novedad Turno
          </Button>
        )}
      </div>
      <AlertsInformativos type={'info'} title={'info'} content={alertInformativo.novedadesTurnos} />
      <Divider sx={{ marginBottom: mtDividerUpTable }} />

      <CreateDialogNovedadesTurnos
        open={openNovedad}
        handleCloseDialogNovedad={handleCloseDialogNovedad}
      />
      <TableNovedadesTurno />
    </>
  );
};
